import type { AuditLogEntry } from './types';

/**
 * How many loaded entries share each request id. It counts only the pages loaded so far,
 * but one request's entries are adjacent in id order, so a group is split only where a
 * page ends.
 */
export function countByRequestId(entries: readonly AuditLogEntry[]): ReadonlyMap<string, number> {
    const counts = new Map<string, number>();
    for (const { requestId } of entries) {
        if (requestId !== null) counts.set(requestId, (counts.get(requestId) ?? 0) + 1);
    }
    return counts;
}

/** The count to show on an entry's request pill, or null when it is alone. */
export function sharedRequestCount(
    counts: ReadonlyMap<string, number>,
    entry: AuditLogEntry
): number | null {
    const count = entry.requestId === null ? 0 : (counts.get(entry.requestId) ?? 0);
    return count >= 2 ? count : null;
}

/** For the dialog's "Show this request" pivot, which counts the entry itself. */
export function loadedRequestCount(
    counts: ReadonlyMap<string, number>,
    entry: AuditLogEntry
): number {
    if (entry.requestId === null) return 0;
    return Math.max(1, counts.get(entry.requestId) ?? 0);
}
